import React from 'react'

import {
  SkeletonLoader,
  Spinner,
  Thumb,
  ThumbContainer,
  ThumbContainerFooter,
  Flex
} from 'mailup-web-components'

const SkeletonResult = () => {
  return (
    <ThumbContainer>
      <Thumb>
        <Spinner />
      </Thumb>
      <ThumbContainerFooter>
        <Flex padding='16px 16px 8px 16px'>
          <SkeletonLoader height='15px' />
        </Flex>
      </ThumbContainerFooter>
    </ThumbContainer>
  )
}

export default SkeletonResult
